import React, { useEffect, useRef, useState } from "react";
import { Styles } from "./styles";
import {
  Col,
  Container,
  Dropdown,
  Nav,
  NavDropdown,
  Navbar,
  Row,
  Spinner,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo.webp";
import MainButton from "../common/buttons/mainButton/MainButton";
import environment from "../../environment";
import Notifications from "./notifications/Notifications";
import { useMediaQuery } from "../../helpers/useMediaQuery";
import { logout } from "../../services/auth.service";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./language-switcher";
import { getAllCategory } from "../../services/categories.service";
import Loader from "../common/loader/Loader";
import Error from "../common/error/Error";
import { useDispatch, useSelector } from "react-redux";
import { getAllNotifications } from "../../services/notifications.service";

const SiteNavbar = ({ initBG }) => {
  const isTablet = useMediaQuery("(max-width: 992px)");
  const navigate = useNavigate();
  const location = useLocation();

  const _token = environment.TOKEN_KEY;
  const _refresh_token = environment.REFRESH_TOKEN_KEY;
  const _notVerified = environment.NOT_VERIFIED;
  const notVerified = localStorage.getItem(_notVerified);
  const [isLoading, setIsLoading] = useState(false);
  const [category, setCategory] = useState();
  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  // const [notifications, setNotifications] = useState();
  // const [isNotificationsLoading, setIsNotificationsLoading] = useState(false);
  const [showNavbarDropdown, setShowNavbarDropdown] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const navRef = useRef(null);

  const { t, i18n } = useTranslation();
  const isAr = i18n.language === "ar";

  // data from stora
  const data = useSelector((state) => state.student.profileData);
  const isDataLoading = useSelector((state) => state.student.isLoading);
  const Resource = useSelector((state) => state.translation.resource);

  //state
  const [show, setShow] = useState(false);

  const getCategory = async () => {
    setIsCategoryLoading(true);
    const response = await getAllCategory();
    if (response?.status === 200) {
      setCategory(response?.data?.data);
      setIsCategoryLoading(false);
    } else {
      setIsCategoryLoading(false);
    }
  };

  // const getNotifications = async () => {
  //   setIsNotificationsLoading(true);
  //   const response = await getAllNotifications();
  //   if (response?.data?.status) {
  //     setNotifications(response?.data?.data?.notifications);
  //     setIsNotificationsLoading(false);
  //   } else {
  //     setIsNotificationsLoading(false);
  //   }
  // };

  const Logout = async () => {
    setIsLoading(true);
    const response = await logout();
    if (response?.status === 200) {
      setIsLoading(false);
      localStorage.removeItem(_token);
      localStorage.removeItem(_refresh_token);
      navigate("/");
      window.location.reload();
    } else {
      setIsLoading(false);
      localStorage.removeItem(_token);
      localStorage.removeItem(_refresh_token);
      navigate("/");
      window.location.reload();
    }
  };

  // functions toggle navbar and dropdown
  const handleShowNavbarDropdownToggle = (nextShow) => {
    setShowNavbarDropdown(nextShow);
  };

  const handleShowUserDropdownToggle = (nextShow) => {
    setShowUserDropdown(nextShow);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleNavbarToggle = (isExpanded) => {
    setExpanded(isExpanded);
  };

  window.addEventListener("scroll", () => {
    if (!initBG) {
      let value = window.scrollY;
      if (value > 0) {
        if (document.getElementById("navbar")) {
          document.getElementById("navbar")?.classList?.add("sticky");
        }
      } else {
        if (document.getElementById("navbar")) {
          document.getElementById("navbar")?.classList?.remove("sticky");
        }
      }
    }
  });

  const isShow = (show) => {
    if (!initBG) {
      let value = window.scrollY;
      if (!show && value < 1) {
        document.getElementById("navbar")?.classList?.add("sticky");
        setShow(true);
      } else if (isShow && value < 1) {
        document.getElementById("navbar")?.classList?.remove("sticky");
        setShow(false);
      } else {
        setShow(false);
      }
    }
  };

  // useEffects
  useEffect(() => {
    getCategory();
  }, []);

  useEffect(() => {
    setShowNavbarDropdown(false);
    setShowUserDropdown(false);
    setExpanded(false);
  }, [location]);

  return (
    <Styles>
      <Navbar
        id="navbar"
        className={initBG && "init-bg"}
        expand="lg"
        expanded={expanded}
        onToggle={handleNavbarToggle}
        ref={navRef}
      >
        <Container>
          <Navbar.Brand>
            <Link to="/">
              <img src={Logo} alt="logo" />
            </Link>
          </Navbar.Brand>
          <div className="mobile">
            {isTablet && <LanguageSwitcher />}
            {/* {localStorage.getItem(_token) && isTablet && (
              <Dropdown className="user notifications">
                <Dropdown.Toggle>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="35"
                    viewBox="0 0 44.738 52.193"
                    onClick={getNotifications}
                  >
                    <g id="Notification" transform="translate(1.25 1.25)">
                      <path
                        id="Stroke-1"
                        d="M21.119,39.375c14.011,0,20.493-1.8,21.119-9.012,0-7.21-4.519-6.746-4.519-15.592C37.719,7.862,31.17,0,21.119,0s-16.6,7.862-16.6,14.771C4.519,23.617,0,23.154,0,30.363.628,37.6,7.11,39.375,21.119,39.375Z"
                        fill="none"
                        stroke="#6f2877"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2.5"
                        fillRule="evenodd"
                      />
                      <path
                        id="Stroke-3"
                        d="M18.118,18.857a7.864,7.864,0,0,1-12.1,0"
                        transform="translate(8.937 27.996)"
                        fill="none"
                        stroke="#6f2877"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2.5"
                        fillRule="evenodd"
                      />
                    </g>
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  style={
                    isAr
                      ? { left: "0", right: "auto" }
                      : { right: "0", left: "auto" }
                  }
                >
                  <Notifications
                    notifications={notifications}
                    isLoading={isNotificationsLoading}
                  />
                </Dropdown.Menu>
              </Dropdown>
            )} */}
            <Navbar.Toggle
              aria-controls="navbarScroll"
              onClick={() => {
                isShow(show);
              }}
            />
          </div>
          <Navbar.Collapse id="navbarScroll">
            <Nav className="my-2 my-lg-0" navbarScroll>
              <Link className="nav-link" to="/">
                {Resource?.home ? Resource?.home : t("navbar.home")}
              </Link>
              {localStorage.getItem(_token) && !notVerified && (
                <Link className="nav-link" to="/profile/settings">
                  {Resource?.profile ? Resource?.profile : t("navbar.profile")}
                </Link>
              )}
              <NavDropdown
                title={
                  <>
                    {Resource?.courses
                      ? Resource?.courses
                      : t("navbar.courses")}
                    <i className="fa-solid fa-chevron-down"></i>
                  </>
                }
                show={showNavbarDropdown}
                onToggle={handleShowNavbarDropdownToggle}
                id="navbarScrollingDropdown"
                className="navbar-dropdown"
              >
                {/* <Link to="/courses" className="title">
                  {Resource?.all_courses
                    ? Resource?.all_courses
                    : t("navbar.all_courses")}
                </Link>
                <NavDropdown.Divider /> */}
                <Row>
                  {isCategoryLoading ? (
                    <Spinner size="md" className="navbar-dropdown-spinner" />
                  ) : (
                    <>
                      {category?.length > 0 ? (
                        category?.map((item, idx) => {
                          if (idx < 8) {
                            return (
                              <Col
                                key={idx}
                                lg={4}
                                sm={6}
                                className="dropdown-item-col"
                              >
                                <Link
                                  className="dropdown-item"
                                  to={`/courses/${item?.id}`}
                                >
                                  {/* <div className="course-image">
                                    <img src={item?.iconUrl} alt={item?.title} />
                                  </div> */}
                                  <span className="course-name">
                                    {item?.localizedName}
                                  </span>
                                </Link>
                              </Col>
                            );
                          }
                        })
                      ) : (
                        <Error
                          message={
                            Resource?.no_categories
                              ? Resource?.no_categories
                              : t("no_categories")
                          }
                          paddingTop={"10px"}
                          height={"fit-content"}
                        />
                      )}
                      <Col lg={4} sm={6} className="dropdown-item-col">
                        <Link className="dropdown-item" to="/courses/all">
                          <span className="course-name arrow">
                            <i
                              className="fa-solid fa-circle-chevron-left"
                              style={
                                isAr
                                  ? { transform: "rotate(0deg)" }
                                  : { transform: "rotate(180deg)" }
                              }
                            ></i>
                          </span>
                        </Link>
                      </Col>
                    </>
                  )}
                </Row>
              </NavDropdown>
              <Link className="nav-link" to="/activities">
                {Resource?.activities
                  ? Resource?.activities
                  : t("navbar.activities")}
              </Link>
              <Link className="nav-link" to="/scientific-certified">
                {Resource?.certified_scientific
                  ? Resource?.certified_scientific
                  : t("certified_scientific")}
              </Link>
              <Link className="nav-link" to="/contact-us">
                {Resource?.contact_us
                  ? Resource?.contact_us
                  : t("navbar.contact_us")}
              </Link>

              {/* <a className="nav-link" href="/testHome">
                test leaderboard
              </a> */}
            </Nav>
            {!isTablet && <LanguageSwitcher />}
            {localStorage.getItem(_token) ? (
              <div className="user-data">
                <Dropdown
                  className="user"
                  show={showUserDropdown}
                  onToggle={handleShowUserDropdownToggle}
                >
                  <Dropdown.Toggle>
                    {isDataLoading ? (
                      <Spinner className="navspinner" size="md" />
                    ) : (
                      <>
                        {data?.avatar ? (
                          <div className="user-img">
                            <img src={data?.avatar} alt="user image" />
                          </div>
                        ) : (
                          <div className="avatar">
                            <svg
                              id="user"
                              xmlns="http://www.w3.org/2000/svg"
                              width="23.867"
                              height="30.3"
                              viewBox="0 0 23.867 30.3"
                            >
                              <path
                                id="Path_1384"
                                data-name="Path 1384"
                                d="M23.4,10.7A7.7,7.7,0,1,1,15.7,3a9.041,9.041,0,0,1,2.047.275C20.712,3.818,23.4,6.945,23.4,10.7Zm-3.85,0A3.85,3.85,0,1,1,15.7,6.85,3.85,3.85,0,0,1,19.55,10.7Z"
                                transform="translate(-3.766 -3)"
                                fill="#fff"
                                fillRule="evenodd"
                              />
                              <path
                                id="Path_1385"
                                data-name="Path 1385"
                                d="M25.891,17.967A1.989,1.989,0,0,0,23.9,15.978H11.967a1.989,1.989,0,0,0-1.989,1.989V29.9H6V17.967A5.967,5.967,0,0,1,11.967,12H23.9a5.967,5.967,0,0,1,5.967,5.967V29.9H25.891Z"
                                transform="translate(-6 0.4)"
                                fill="#fff"
                              />
                            </svg>
                          </div>
                        )}
                        <div className="content">
                          {isAr ? (
                            <>
                              {data?.firstNameAr}&nbsp;
                              {data?.lastNameAr}
                            </>
                          ) : (
                            <>
                              {data?.firstNameEn}&nbsp;
                              {data?.lastNameEn}
                            </>
                          )}
                        </div>
                        <i className="fa-solid fa-chevron-down"></i>
                      </>
                    )}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {!notVerified ? (
                      <>
                        <Link className="nav-link" to="/profile/courses">
                          {Resource?.my_courses
                            ? Resource?.my_courses
                            : t("navbar.my_courses")}
                        </Link>
                        <Link className="nav-link" to="/profile/settings">
                          {Resource?.profile
                            ? Resource?.profile
                            : t("navbar.profile")}
                        </Link>
                        <Link className="nav-link" to="/profile/details">
                          {t("profile.header.statistics_and_skills")}
                          {/* {Resource?.settings
                            ? Resource?.settings
                            : t("navbar.settings")} */}
                        </Link>
                      </>
                    ) : (
                      <Link className="nav-link" to="/verify-account">
                        {Resource?.verify_account
                          ? Resource?.verify_account
                          : t("verify_account")}
                      </Link>
                    )}
                    <MainButton
                      buttonText={
                        isLoading ? (
                          <Spinner size="sm" />
                        ) : Resource?.log_out ? (
                          Resource?.log_out
                        ) : (
                          t("navbar.log_out")
                        )
                      }
                      buttonClick={Logout}
                    />
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            ) : (
              <Link to="/login">
                <MainButton
                  buttonText={
                    Resource?.login ? Resource?.login : t("navbar.log_in")
                  }
                />
              </Link>
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Styles>
  );
};

export default SiteNavbar;
